import { render, staticRenderFns } from "./HomeYjjM.vue?vue&type=template&id=926d208e&scoped=true&"
import script from "./HomeYjjM.vue?vue&type=script&lang=js&"
export * from "./HomeYjjM.vue?vue&type=script&lang=js&"
import style0 from "./HomeYjjM.vue?vue&type=style&index=0&id=926d208e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926d208e",
  null
  
)

export default component.exports